import { render } from "./CalloutsSection.vue?vue&type=template&id=0820b521&scoped=true"
const script = {}

import "./CalloutsSection.vue?vue&type=style&index=0&id=0820b521&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0820b521"]])

export default __exports__